export default __webpack_public_path__ + "static/media/moviedb.515888a3.png";